/**
 * Split out of src/utils/Text.ts so a consumer that needs only this can have
 * it: Text.ts imports html-react-parser at module scope for its other exports,
 * and neither that package nor this app declares `sideEffects`, so importing
 * Text.ts drags the whole parser (~71 kB gzip) into the client bundle.
 */
export const titleCase = (value: string): string => {
  if (!value) {
    return ``;
  }
  return value
    .split(" ")
    .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
    .join(" ");
};
